import axios from 'axios';

// Create an axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds
});

// Add a request interceptor to inject auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(process.env.REACT_APP_JWT_STORAGE_KEY);
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors - redirect to login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(process.env.REACT_APP_JWT_STORAGE_KEY);
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

// Specialized function for multipart/form-data requests
export const uploadApi = (endpoint, formData, onUploadProgress) => {
  const token = localStorage.getItem(process.env.REACT_APP_JWT_STORAGE_KEY);
  
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API_URL}${endpoint}`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: token ? `Bearer ${token}` : '',
    },
    onUploadProgress,
  });
};

export default api;